import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from 'src/environments/environment';

import { deserialize } from '../../shared/models/base-helper';
import { SiteStatusLog } from '../../shared/models/site-status-log';

@Injectable({
  providedIn: 'root',
})
export class SiteStatusLogsService {
  apiUrl = environment.apiUrl + '/site_status_logs/';

  constructor(readonly http: HttpClient) {}

  getSiteLogs(id: number): Observable<SiteStatusLog[]> {
    return this.http
      .get<any[]>(`${this.apiUrl}${id}`)
      .pipe(
        map(logs => logs.map((serializedSiteStatusLog: any) => deserialize(serializedSiteStatusLog, SiteStatusLog)))
      );
  }
}
